import http from './http'

export function getChart(url) {
	return http({
		method: 'GET',
		url: url
	})
}
